module.exports = __webpack_public_path__ + "static/media/newbury.803ee008.jpg";